import React from 'react';
import { Tag } from 'antd';
import {
  ClockCircleOutlined,
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { SandboxStatus } from '../../types/sandbox';

interface StatusBadgeProps {
  status: SandboxStatus;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const statusConfig: Record<
    SandboxStatus,
    { color: string; text: string; icon: React.ReactNode }
  > = {
    pending: {
      color: 'default',
      text: 'Pending',
      icon: <ClockCircleOutlined />,
    },
    creating: {
      color: 'processing',
      text: 'Creating',
      icon: <SyncOutlined spin />,
    },
    ready: {
      color: 'success',
      text: 'Ready',
      icon: <CheckCircleOutlined />,
    },
    failed: {
      color: 'error',
      text: 'Failed',
      icon: <CloseCircleOutlined />,
    },
    deleting: {
      color: 'warning',
      text: 'Deleting',
      icon: <DeleteOutlined />,
    },
  };

  const config = statusConfig[status] || statusConfig.pending;

  return (
    <Tag color={config.color} icon={config.icon}>
      {config.text}
    </Tag>
  );
};
